import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'KnowFi';
const SITE_URL  = 'https://knowfi.io';
const DEFAULT_DESC = 'Finance explained without the BS. Free financial tools, daily market brief, AI money coach, and personal finance tracker. No jargon. No suits. Just clarity.';
const DEFAULT_IMG  = `${SITE_URL}/og-image.png`;

// path prop is optional — if omitted, auto-detects from current URL
export default function SEO({ title, description, path, image, keywords, type = 'website', publishedDate, author }) {
  const location = useLocation();
  const canonicalPath = path !== undefined ? path : location.pathname;

  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Finance Explained Without the BS`;
  const desc  = description || DEFAULT_DESC;
  const url   = `${SITE_URL}${canonicalPath}`;
  const img   = image || DEFAULT_IMG;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type"        content={type} />
      <meta property="og:url"         content={url} />
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image"       content={img} />
      <meta property="og:site_name"   content={SITE_NAME} />
      {publishedDate && <meta property="article:published_time" content={publishedDate} />}
      {author && <meta property="article:author" content={author} />}

      {/* Twitter Card */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image"       content={img} />
    </Helmet>
  );
}
